import { Outlet , useLocation } from "react-router-dom";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import ButtonScrollTop from "./components/layout/Buttons/ButtonScrollTop";
import LiveChatWidget from "./components/layout/LiveChatWidget";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";




function App() {
  const location = useLocation(); 
  const hideHeaderAndFooterPaths = [
    "/login",
    "/signup",
    "/forgot_password",
    "/order_success",
  ];
  const showHeaderAndFooter = !hideHeaderAndFooterPaths.includes(location.pathname);

  return (
    <>
      <LiveChatWidget />
      <ToastContainer />
      {showHeaderAndFooter && <Header />}
      <main className="customer-main-content with-top-clearance-margin">
        <Outlet />
      </main>
      <ButtonScrollTop />
      {showHeaderAndFooter && <Footer />}
    </>
  );
}

export default App;
